
export function i18nAllObject(vueEntity: any, object: any): any {
  Object.keys(object).forEach(
    (key: string): void => {
      object[key] = vueEntity.$t(object[key]);
    }
  );
  return object;
}
export function i18nObjectByKey(vueEntity: any, object: any, key: string): any {
  object[key] = vueEntity.$t(object[key]);
  return object;
}
export function i18nListByKey(vueEntity: any, arr: any, key: string): any {
  let data: any = [];
  arr.forEach(
    (item: any): void => {
      item[key] = vueEntity.$t(item[key]);
      data.push(item);
    }
  );
  arr = data;
  return arr;
}
export function i18nInObjectList(vueEntity: any, obj: any, listKey: string, key: string): any {
  let data: any = [];
  obj[listKey].forEach(
    (item: any): void => {
      item[key] = vueEntity.$t(item[key]);
      data.push(item);
    }
  );
  obj[listKey] = data;
  return obj;
}

export const makeFastFuncOfGetI18n = (basePath: string) => (key: string, optionValues?: { [key: string] : string }): string => {
  return window.$t(basePath + '_' + key, optionValues) as string;
}